import React from "react";
import { createRoot, Root } from "react-dom/client";
import { flushSync } from "react-dom";
// @ts-ignore - overlay.jsx is a React component without TypeScript declarations
import Overlay from "./overlay.jsx";
import { Session } from "../../../index.js";
import { log } from "@tumbodash/browserPackages";

let overlayRoot: Root | null = null;

function init(sessionId: string, mountId: string) {
	log.sessionFx("(client/menu/type3/overlay/init)");

	const rootContainer = document.getElementById(mountId);
	let overlayDiv = document.getElementById("overlay-root");

	if (!overlayDiv) {
		overlayDiv = document.createElement("div");
		overlayDiv.id = "overlay-root";
		rootContainer!.appendChild(overlayDiv);
	}
	if (!overlayRoot) {
		overlayRoot = createRoot(overlayDiv);
	}
	const overlayRef = React.createRef();

	flushSync(() => {
		overlayRoot!.render(React.createElement(Overlay, { sessionId, ref: overlayRef }));
	});

	const session = Session.get(sessionId);
	if (session) {
		(session.cleanup as Array<() => void>).push(() => {
			log.sessionFx("(client/menu/type3/overlay/init/cleanup)");
			if (overlayRoot) {
				Promise.resolve().then(() => {
					overlayRoot!.unmount();
					overlayRoot = null;
				});
			}
			if (overlayDiv) {
				overlayDiv.remove();
			}
		});
	}
	return overlayRef;
}

export default init;
